import { Component, EventEmitter, Input, OnInit } from '@angular/core';
import { BaseComponent } from 'src/app/core/base.component';
import { SessionService } from 'src/app/shared/services/session.service';
import { StringHelpers } from 'src/app/shared/helpers/string-helpers';
import { DigitalWaiverService } from '../../services/digital-waiver.service';
import { DigitalWaiver } from '../../models/digital-waiver';
import { Sort } from '@angular/material/sort';
import { MatDialog } from '@angular/material/dialog';
import { AlertModalComponent } from 'src/app/shared/modals/alert-modal/alert-modal.component';
import { WaiverQueryFilter } from './waiver-list-query-filter';
import { WaiverCreateModalComponent } from '../../modals/waiver/waiver-create-modal/waiver-create-modal.component';
import { WaiverEditModalComponent } from '../../modals/waiver/waiver-edit-modal/waiver-edit-modal.component';

@Component({
  selector: 'app-waivers-list',
  templateUrl: './waivers-list.component.html',
  styleUrl: './waivers-list.component.scss',
  standalone: false
})
export class WaiversListComponent extends BaseComponent implements OnInit {
  @Input() filter: WaiverQueryFilter = new WaiverQueryFilter();
  public updateFilterEvent = new EventEmitter<any>();
  public waivers: DigitalWaiver[] = [];
  public displayedColumns: string[] = ['title', 'isActive', 'lastEditedDate', 'actions'];

  constructor(
    sessionService: SessionService,
    private digitalWaiverService: DigitalWaiverService,
    private dialog: MatDialog,
    stringHelpers: StringHelpers
  ) {
    super(sessionService, stringHelpers);
    this.filter.organizationId = this.sessionService.getUser().organizationId;
  }

  ngOnInit(): void {
    this.getWaivers();
  }

  getWaivers() {
    this.isLoading = true;
    this.digitalWaiverService.getWaiversByOrganization(this.filter).subscribe({
      next: (result) => {
        this.waivers = result.results;
        this.filter.totalCount = result.totalCount;
        this.updateFilterEvent.emit(result.results);
      },
      error: (error) => {
        this.isLoading = false;
        console.error(error);
      },
      complete: () => this.isLoading = false
    });
  }

  sortData(sort: Sort) {
    this.filter.sortDirection = sort.direction;
    this.filter.sortColumn = sort.active;
    this.getWaivers();
  }

  resetFilter() {
    this.filter.page = 1;
    this.filter.text = '';
    this.filter.pageSize = 15;
  }

  createWaiver() {
    const dialogRef = this.dialog.open(WaiverCreateModalComponent, {
      width: 'auto'
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result === 'save') {
        this.getWaivers();
      }
    });
  }

  edit(waiver: DigitalWaiver) {
    const dialogRef = this.dialog.open(WaiverEditModalComponent, {
      width: 'auto'
    });

    dialogRef.componentInstance.waiver = waiver;

    dialogRef.afterClosed().subscribe(result => {
      if (result === 'save') {
        this.getWaivers();
      }
    });
  }

  updateIsActive(waiver: DigitalWaiver, event) {
    this.isLoading = true;
    waiver.isActive = event;
    waiver.lastEditedBy = this.sessionService.getUserId();
    this.digitalWaiverService.updateWaiver(waiver.id, waiver).subscribe({
      next: () => {
        this.getWaivers();
      },
      error: (error) => {
        this.isLoading = false;
        console.error(error);

        if (error.status === 400) {
          const validationErrors = error.error.errors;
          this.alert('Error', validationErrors?.IsActive[0], 'OK');
        }

      },
      complete: () => this.isLoading = false
    });
  }

  delete(waiver: DigitalWaiver) {
    const dialogRef = this.dialog.open(AlertModalComponent);
    dialogRef.componentInstance.title = 'Delete Waiver';
    dialogRef.componentInstance.body = `<h3 class="text-danger mat-h3">WARNING! THIS ACTION CANNOT BE UNDONE</h3> <br /> Are you sure you want to delete Waiver <strong>${waiver.title}</strong>?`;
    dialogRef.componentInstance.submitText = 'Yes';
    dialogRef.componentInstance.otherText = 'No';
    dialogRef.componentInstance.isOtherTextDisabled = false;
    dialogRef.afterClosed().subscribe((response) => {
      if (response === 'Yes') {
        this.isLoading = true;
        let data = { id: waiver.id, lastEditedBy: this.getUserIdFromSession() };
        this.digitalWaiverService.deleteWaiver(data).subscribe(() => {
          this.getWaivers();
          this.isLoading = false;
        }, err => {
          this.isLoading = false;
          console.error(err);
        });
      }
    });
  }

  alert(title, body, submitText) {
    const dialogRef = this.dialog.open(AlertModalComponent, {
      width: 'auto',
    });

    dialogRef.componentInstance.title = title;
    dialogRef.componentInstance.body = body;
    dialogRef.componentInstance.submitText = submitText;

    dialogRef.afterClosed().subscribe(() => {
      this.getWaivers();
    });
  }
}
